import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/pro-light-svg-icons'

import ContentHolder from '../../ui/ContentHolder'

import styles from './styles.scss'

const Download = (props) => {
  const { artwork, text } = props

  if (!artwork || !artwork.links) return null

  return (
    <div className={styles.root}>
      <ContentHolder>
        <div className={styles.content}>
          <span className={styles.text}>{text}</span>
          <a href={artwork.links.download_url} className={styles.button} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faDownload} className={styles.icon} />Download
          </a>
        </div>
      </ContentHolder>
    </div>
  )
}

Download.propTypes = {
  artwork: PropTypes.object.isRequired,
  text: PropTypes.string,
}

export default Download
